export default __webpack_public_path__ + "static/media/3.2a03f7a1.jpg";